import { updateUserAttributes } from 'aws-amplify/auth';
import { useState } from 'react';

type UserAttributes = Record<string, string>;

export const useUpdatePasswordResetTimestamp = () => {
  const { updateAttributes } = useUpdateUserAttributes();

  const updatePasswordResetTimestamp = async () => {
    await updateAttributes({
      updated_at: Date.now().toString(),
    });
  };

  return updatePasswordResetTimestamp;
};

/**
 * Hook for updating AWS Cognito user attributes
 */
export function useUpdateUserAttributes(): {
  isUpdating: boolean;
  error: string | null;
  updateAttributes: (attributes: UserAttributes) => Promise<boolean>;
} {
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updateAttributes = async (
    attributes: UserAttributes
  ): Promise<boolean> => {
    try {
      setIsUpdating(true);
      setError(null);

      await updateUserAttributes({
        userAttributes: attributes,
      });

      return true;
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : 'Failed to update user attributes';
      setError(errorMessage);
      console.error('Error updating user attributes:', err);
      return false;
    } finally {
      setIsUpdating(false);
    }
  };

  return {
    isUpdating,
    error,
    updateAttributes,
  };
}
